<template>
    <v-fade-transition>
        <div
            v-if="visible"
            class="loader">
            <transition name="loader-fade">
                <div
                    v-if="stage === 'text'"
                    key="text"
                    class="loader__content">
                    Loading
                </div>
                <div
                    v-else-if="stage === 'logo'"
                    key="logo"
                    class="loader__content">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="77.654"
                        height="77.654"
                        viewBox="0 0 77.654 77.654"
                        class="mt-1">
                        <g transform="translate(-166.184 -2.322)">
                            <g transform="translate(166.184 2.322)">
                                <path
                                    d="M205.011,79.976a38.827,38.827,0,1,1,38.827-38.827A38.871,38.871,0,0,1,205.011,79.976Zm0-72.623a33.8,33.8,0,1,0,33.8,33.8A33.834,33.834,0,0,0,205.011,7.353Z"
                                    transform="translate(-166.184 -2.322)"
                                    fill="#fff" />
                            </g>
                            <path
                                d="M210.034,63.591a6.4,6.4,0,0,1,6.157-4.25c3.972,0,7.07,2.661,7.07,6.712V79.836c0,1.628.715,2.383,2.026,2.383.913,0,1.311-.556,1.668-1.669l5.481-16.96a6.348,6.348,0,0,1,6.157-4.25c3.972,0,7.07,2.661,7.07,6.712V86.787h-5.084V66.53c0-1.589-.715-2.383-2.066-2.383-.874,0-1.271.635-1.628,1.747l-5.561,16.921a6.159,6.159,0,0,1-6.116,4.29c-3.932,0-7.03-2.661-7.03-6.713V66.53c0-1.589-.715-2.383-2.065-2.383-.874,0-1.231.635-1.629,1.747l-7.308,20.893h-5.4Z"
                                transform="translate(-20.019 -32.074)"
                                fill="#fff" />
                        </g>
                    </svg>
                </div>
            </transition>
            <v-fade-transition>
                <div
                    v-if="stage !== 'logo'"
                    class="ripple">
                    <div />
                    <div />
                </div>
            </v-fade-transition>
        </div>
    </v-fade-transition>
</template>

<script>
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const pageLoaded = () =>
    new Promise((resolve) => {
        if (document.readyState === 'complete') resolve();
        else window.addEventListener('load', resolve, { once: true });
    });

/**
 * Full-screen intro shown until the page has finished loading: "Loading" text
 * and a ripple spinner, then the logo, then the whole overlay fades out.
 */
export default {
    name: 'AppLoader',
    data: () => ({
        visible: true,
        stage: 'text', // 'text' -> 'none' -> 'logo'
    }),
    async mounted() {
        await pageLoaded();
        await sleep(500);
        this.stage = 'none';
        await sleep(500);
        this.stage = 'logo';
        await sleep(2000);
        this.visible = false;
    },
};
</script>

<style scoped>
.loader {
    z-index: 5;
    position: fixed;
    top: 0px;
    width: 100vw;
    height: 100vh;
    background: radial-gradient(#222222, #000000);
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader__content {
    color: rgb(255, 255, 255);
    font-size: 1.5vw;
    font-family: roboto;
    font-weight: 300;
    position: absolute;
    filter: blur(0px);
}

.loader-fade-enter-active {
    transition: all 0.5s 0.3s cubic-bezier(0.11, 1.04, 0.8, 0.99);
}
.loader-fade-leave-active {
    transition: all 0.3s cubic-bezier(0.68, 0.04, 1, 0.7);
}
.loader-fade-enter,
.loader-fade-leave-to {
    transform: scale(1.8);
    filter: blur(10px);
    opacity: 0;
}

/* Two rings expanding from the center, half a cycle apart. */
.ripple {
    position: relative;
    display: inline-block;
    width: 334px;
    height: 334px;
    overflow: hidden;
    transform: translateZ(0);
}
.ripple div {
    position: absolute;
    box-sizing: content-box;
    border-width: 3.34px;
    border-style: solid;
    border-radius: 50%;
    animation: ripple 3.125s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.ripple div:nth-child(1) {
    border-color: #ffffff;
}
.ripple div:nth-child(2) {
    border-color: #009eeb;
    animation-delay: -1.5625s;
}
@keyframes ripple {
    0% {
        top: 163.66px;
        left: 163.66px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: 45.09px;
        left: 45.09px;
        width: 237.14px;
        height: 237.14px;
        opacity: 0;
    }
}
</style>
